import http from '../utils/http'


// 退出登录
export function loginOutApi(){
    return http.get('/logout')
}